import MuiTimelineDot from '@mui/lab/TimelineDot';

import { useTimelineDotVariantStyles } from './config';
import { CustomTimelineDotProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const TimelineDot: React.FC<CustomTimelineDotProps> = (props) => {
  const { sx, skin, color = 'grey', variant = 'filled' } = props;

  // =============== HOOKS
  const colors = useTimelineDotVariantStyles();

  // =============== VIEWS
  return (
    <MuiTimelineDot
      {...props}
      sx={
        color && skin === 'light' && variant === 'filled'
          ? Object.assign(colors[color], sx)
          : sx
      }
    />
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default TimelineDot;
